import React, {
  useEffect,
} from 'react';
import { setPageMeta, routes } from 'appConstants';
import { Vacancies as Container } from 'containers';

const Vacancies = () => {
  useEffect(() => {
    setPageMeta(routes.vacancies.title, routes.vacancies.descr);
  });

  return <Container />;
};

export default Vacancies;
